var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAutoCancelled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6328_689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.625 11.25C6.31536 11.25 6.875 10.6904 6.875 10C6.875 9.30964 6.31536 8.75 5.625 8.75C4.93464 8.75 4.375 9.30964 4.375 10C4.375 10.6904 4.93464 11.25 5.625 11.25Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.375 11.25C15.0654 11.25 15.625 10.6904 15.625 10C15.625 9.30964 15.0654 8.75 14.375 8.75C13.6846 8.75 13.125 9.30964 13.125 10C13.125 10.6904 13.6846 11.25 14.375 11.25Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 11.25C10.6904 11.25 11.25 10.6904 11.25 10C11.25 9.30964 10.6904 8.75 10 8.75C9.30964 8.75 8.75 9.30964 8.75 10C8.75 10.6904 9.30964 11.25 10 11.25Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 18.75C8.26942 18.75 6.57769 18.2368 5.13876 17.2754C3.69983 16.3139 2.57832 14.9473 1.91606 13.3485C1.25379 11.7496 1.08051 9.99029 1.41813 8.29296C1.75575 6.59563 2.58911 5.03653 3.81282 3.81282C5.03653 2.58911 6.59563 1.75575 8.29296 1.41813C9.9903 1.08051 11.7496 1.25379 13.3485 1.91605C14.9473 2.57832 16.3139 3.69983 17.2754 5.13876C18.2368 6.57769 18.75 8.26941 18.75 10C18.7474 12.3198 17.8247 14.5439 16.1843 16.1843C14.5439 17.8247 12.3198 18.7474 10 18.75ZM10 2.5C8.51664 2.5 7.0666 2.93987 5.83323 3.76398C4.59986 4.58809 3.63856 5.75943 3.07091 7.12987C2.50325 8.50032 2.35473 10.0083 2.64411 11.4632C2.9335 12.918 3.64781 14.2544 4.6967 15.3033C5.7456 16.3522 7.08197 17.0665 8.53683 17.3559C9.99168 17.6453 11.4997 17.4968 12.8701 16.9291C14.2406 16.3614 15.4119 15.4001 16.236 14.1668C17.0601 12.9334 17.5 11.4834 17.5 10C17.4977 8.01157 16.7068 6.10523 15.3008 4.6992C13.8948 3.29317 11.9884 2.50227 10 2.5Z",
    fill: "#263238"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6328_689"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoCancelled);
export default __webpack_public_path__ + "static/media/AutoCancelled.d9c25d9cf9d930766c5f684145272be7.svg";
export { ForwardRef as ReactComponent };